import { isNil, isEmpty } from 'ramda';
import { useDebouncedCallback } from 'use-debounce';

const DEBOUNCE_TIME = 400;

export const isBlank = value => {
  return isNil(value) || isEmpty(value);
};

export const isPresent = value => !isBlank(value);

export const upperFirstLetter = string => {
  if (!string) return string;

  return string[0].toUpperCase() + string.slice(1);
};

export const isEven = number => number % 2 === 0;

export const Debounce = (func, time = DEBOUNCE_TIME) => {
  return useDebouncedCallback(func, time);
};

export const humanizeString = string => {
  return string
    .split('_')
    .map(w => upperFirstLetter(w))
    .join(' ');
};



// WEBPACK FOOTER //
// ./src/utils/helperMethods.js